import type { PropertyResponse } from '@/shared/api';
import { FlatFamilyBadge } from '../flat-family';
import { MetaStrip } from './MetaStrip';
import { StatusPill } from './StatusPill';

interface Props {
  property: PropertyResponse;
  channelsActive: number;
  channelsTotal: number;
}

/** Name, Zustand und Kennzeile des Apartments — die Antwort auf „wo bin ich?" (§4). */
export function ApartmentIdentity({ property, channelsActive, channelsTotal }: Props) {
  return (
    <div className="mb-6">
      <div className="flex flex-wrap items-center gap-3">
        <h1 className="text-ink font-serif text-3xl font-normal">{property.name}</h1>
        <StatusPill status={property.status} />
        <FlatFamilyBadge family={property.flatFamily} />
      </div>
      <MetaStrip
        city={property.address.city}
        channelsActive={channelsActive}
        channelsTotal={channelsTotal}
        channexConnected={property.channexUnitPublished}
        guests={property.occupancyAdults + property.occupancyChildren}
        bedrooms={property.bedrooms}
        bathrooms={property.bathrooms}
        cleaningFee={property.cleaningFee}
        currency={property.currency}
      />
    </div>
  );
}
